import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AssignmentReportFormGroup } from './assignment-report-form-group.interface';

@Injectable()
export class AssignmentReportFormModel {
  private readonly formBuilder = inject(FormBuilder);

  readonly fieldNames = {
    reportTypeId: 'reportTypeId',
    value: 'value',
    reportDate: 'reportDate',
    comment: 'comment',
  };

  public form: FormGroup<AssignmentReportFormGroup>;

  constructor() {
    this.form = this.initForm();
  }

  private initForm(): FormGroup<AssignmentReportFormGroup> {
    return this.formBuilder.group<AssignmentReportFormGroup>({
      reportTypeId: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      value: new FormControl<number | null>(null, {
        validators: [Validators.required],
      }),
      reportDate: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      comment: new FormControl<string | null>(null, {
        validators: [Validators.maxLength(2048)],
      }),
    });
  }
}
